"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactcss = require("reactcss");

var _reactcss2 = _interopRequireDefault(_reactcss);

var _reactColor = require("react-color");

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require("semantic-ui-react");

var _PanelMapInformation = require("./PanelMapInformation.css");

var _PanelMapInformation2 = _interopRequireDefault(_PanelMapInformation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //     


var PanelMapInformation = function (_Component) {
  _inherits(PanelMapInformation, _Component);

  function PanelMapInformation() {
    _classCallCheck(this, PanelMapInformation);

    var _this = _possibleConstructorReturn(this, (PanelMapInformation.__proto__ || Object.getPrototypeOf(PanelMapInformation)).call(this));

    _this.clickColorPanell = function () {
      _this.setState({
        displayColorPickerPanell: !_this.state.displayColorPickerPanell
      });
    };

    _this.closeColorPanell = function () {
      _this.setState({
        displayColorPickerPanell: false,
        showPanelPropertiesInfoSelector: false
      });
    };

    _this.clickColorPanellText = function () {
      _this.setState({
        displayColorPickerPanellText: !_this.state.displayColorPickerPanellText
      });
    };

    _this.closeColorPanellText = function () {
      _this.setState({ displayColorPickerPanellText: false });
    };

    _this.changeColorPanellText = function (color) {
      _this.props.updateInfowindowProps("colorPanellText", color.rgb);
    };

    _this.changeColorPanell = function (color) {
      _this.props.updateInfowindowProps("colorPanell", color.rgb);
    };

    _this.state = {
      displayColorPickerPanell: false,
      displayColorPickerPanellText: false
    };
    return _this;
  }

  _createClass(PanelMapInformation, [{
    key: "renderToggleTitol",
    value: function renderToggleTitol() {
      var _this2 = this;

      return _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        { className: _PanelMapInformation2.default.row2 },
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { width: 16 },
          _react2.default.createElement(_semanticUiReact.Checkbox, {
            size: "mini",
            id: "viewtitlebar",
            toggle: true,
            onChange: function onChange(e, data) {
              return _this2.props.updateInfowindowProps(data.id, data.checked);
            },
            label: "Mostar barra titol",
            className: _PanelMapInformation2.default.checkStyle,
            checked: this.props.infowindow.viewtitlebar
          })
        )
      );
    }
  }, {
    key: "renderToggleLlegenda",
    value: function renderToggleLlegenda() {
      var _this3 = this;

      return _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        { className: _PanelMapInformation2.default.row2 },
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { width: 16 },
          _react2.default.createElement(_semanticUiReact.Checkbox, {
            id: "viewlegend",
            toggle: true,
            onChange: function onChange(e, data) {
              return _this3.props.updateInfowindowProps(data.id, data.checked);
            },
            label: "Mostrar llegenda",
            className: _PanelMapInformation2.default.checkStyle,
            checked: this.props.infowindow.viewlegend
          })
        )
      );
    }
  }, {
    key: "renderToggleFilter",
    value: function renderToggleFilter() {
      var _this4 = this;

      return _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        { className: _PanelMapInformation2.default.row2 },
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { width: 16 },
          _react2.default.createElement(_semanticUiReact.Checkbox, {
            id: "viewfilter",
            toggle: true,
            onChange: function onChange(e, data) {
              return _this4.props.updateInfowindowProps(data.id, data.checked);
            },
            label: "Mostrar filtre organismes",
            className: _PanelMapInformation2.default.checkStyle,
            checked: this.props.infowindow.viewfilter
          })
        )
      );
    }
  }, {
    key: "renderToggleCercador",
    value: function renderToggleCercador() {
      var _this5 = this;

      return _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        { className: _PanelMapInformation2.default.row2 },
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { width: 16 },
          _react2.default.createElement(_semanticUiReact.Checkbox, {
            id: "viewcercador",
            toggle: true,
            onChange: function onChange(e, data) {
              return _this5.props.updateInfowindowProps(data.id, data.checked);
            },
            label: "Mostrar cercador",
            className: _PanelMapInformation2.default.checkStyle,
            checked: this.props.infowindow.viewcercador
          })
        )
      );
    }
  }, {
    key: "renderPickerColorFonsPanel2",
    value: function renderPickerColorFonsPanel2(stylesPicker) {
      return _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        { className: _PanelMapInformation2.default.row3 },
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { width: 4 },
          _react2.default.createElement(
            "div",
            { style: stylesPicker.swatch, onClick: this.clickColorPanell },
            _react2.default.createElement("div", { style: stylesPicker.colorPanell })
          ),
          this.state.displayColorPickerPanell ? _react2.default.createElement(
            "div",
            { style: stylesPicker.popover },
            _react2.default.createElement("div", { style: stylesPicker.cover, onClick: this.closeColorPanell }),
            _react2.default.createElement(_reactColor.SketchPicker, {
              color: this.props.infowindow.colorPanell,
              label: "true",
              onChange: this.changeColorPanell
            })
          ) : null
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { width: 12 },
          _react2.default.createElement(
            "span",
            null,
            "Color fons "
          )
        )
      );
    }
  }, {
    key: "renderPickerColorTextPanel2",
    value: function renderPickerColorTextPanel2(stylesPicker) {
      return _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        { className: _PanelMapInformation2.default.row3 },
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { width: 4 },
          _react2.default.createElement(
            "div",
            { className: _PanelMapInformation2.default.swatch, onClick: this.clickColorPanellText },
            _react2.default.createElement("div", { style: stylesPicker.colorPanell })
          ),
          this.state.displayColorPickerPanellText ? _react2.default.createElement(
            "div",
            { className: _PanelMapInformation2.default.popover },
            _react2.default.createElement("div", {
              className: _PanelMapInformation2.default.cover,
              onClick: this.closeColorPanellText
            }),
            _react2.default.createElement(_reactColor.SketchPicker, {
              color: this.props.infowindow.colorPanellText,
              label: "true",
              onChange: this.changeColorPanellText
            })
          ) : null
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { width: 12 },
          _react2.default.createElement(
            "span",
            null,
            "Color text "
          )
        )
      );
    }
  }, {
    key: "renderPickerColorFonsPanel",
    value: function renderPickerColorFonsPanel(stylesPicker) {
      return _react2.default.createElement(
        "div",
        { className: _PanelMapInformation2.default.myItemRow },
        _react2.default.createElement(
          _semanticUiReact.Label,
          { className: _PanelMapInformation2.default.cleanLabelBorder, basic: true },
          "Color fons",
          " "
        ),
        _react2.default.createElement(
          "div",
          { className: _PanelMapInformation2.default.swatch, onClick: this.clickColorPanell },
          _react2.default.createElement("div", { style: stylesPicker.colorPanell })
        ),
        this.state.displayColorPickerPanell ? _react2.default.createElement(
          "div",
          { className: _PanelMapInformation2.default.popover },
          _react2.default.createElement("div", { className: _PanelMapInformation2.default.cover, onClick: this.closeColorPanell }),
          _react2.default.createElement(_reactColor.SketchPicker, {
            color: this.props.infowindow.colorPanell,
            label: "true",
            onChange: this.changeColorPanell
          })
        ) : null
      );
    }
  }, {
    key: "renderPickerColorTextPanel",
    value: function renderPickerColorTextPanel(stylesPicker) {
      return _react2.default.createElement(
        "div",
        { className: _PanelMapInformation2.default.myItemRow },
        _react2.default.createElement(
          _semanticUiReact.Label,
          { className: _PanelMapInformation2.default.cleanLabelBorder, basic: true },
          "Color text",
          " "
        ),
        _react2.default.createElement(
          "div",
          { className: _PanelMapInformation2.default.swatch, onClick: this.clickColorPanellText },
          _react2.default.createElement("div", { style: stylesPicker.colorPanellText })
        ),
        this.state.displayColorPickerPanellText ? _react2.default.createElement(
          "div",
          { className: _PanelMapInformation2.default.popover },
          _react2.default.createElement("div", { className: _PanelMapInformation2.default.cover, onClick: this.closeColorPanellText }),
          _react2.default.createElement(_reactColor.SketchPicker, {
            color: this.props.infowindow.colorPanellText,
            label: "true",
            onChange: this.changeColorPanellText
          })
        ) : null
      );
    }
  }, {
    key: "renderHeaderFields",
    value: function renderHeaderFields() {
      var _this6 = this;

      var selected = this.props.calcdatafields;
      var alias = this.props.selectedfieldsLabels;
      var itemH = [];
      selected.map(function (itemHeader, index) {
        return itemH.push(_react2.default.createElement(
          "div",
          { className: _PanelMapInformation2.default.myItemMargin, key: itemHeader },
          _react2.default.createElement(_semanticUiReact.Input, {
            className: _PanelMapInformation2.default.itemLabelInputCamp,
            label: { basic: false, color: "teal", content: itemHeader },
            labelPosition: "left",
            size: "mini",
            id: index,
            onChange: function onChange(e, data) {
              return _this6.props.updateSelectedfieldsLabels(itemHeader, data.value);
            },
            value: alias[itemHeader]
          })
        ));
      });
      return itemH;
    }
  }, {
    key: "renderPanelPropiertiesConfigEstil",
    value: function renderPanelPropiertiesConfigEstil() {
      var stylesPicker = (0, _reactcss2.default)({
        default: {
          colorPanell: {
            width: "36px",
            height: "14px",
            borderRadius: "2px",
            background: "rgba(" + this.props.infowindow.colorPanell.r + ", " + this.props.infowindow.colorPanell.g + ", " + this.props.infowindow.colorPanell.b + ", " + this.props.infowindow.colorPanell.a + ")"
          },
          colorPanellText: {
            width: "36px",
            height: "14px",
            borderRadius: "2px",
            background: "rgba(" + this.props.infowindow.colorPanellText.r + ", " + this.props.infowindow.colorPanellText.g + ", " + this.props.infowindow.colorPanellText.b + ", " + this.props.infowindow.colorPanellText.a + ")"
          }
        }
      });
      return _react2.default.createElement(
        "div",
        { className: _PanelMapInformation2.default.myContainer },
        _react2.default.createElement(
          "h5",
          null,
          "Configurar estil panell:"
        ),
        this.renderPickerColorFonsPanel(stylesPicker),
        this.renderPickerColorTextPanel(stylesPicker)
      );
    }
  }, {
    key: "renderPanelPropertiesConfigFields",
    value: function renderPanelPropertiesConfigFields() {
      return _react2.default.createElement(
        "div",
        { className: _PanelMapInformation2.default.myContainer },
        _react2.default.createElement(
          "h5",
          null,
          "Configurar noms camps:"
        ),
        this.renderHeaderFields()
      );
    }
  }, {
    key: "renderPanelConfig",
    value: function renderPanelConfig() {
      if (this.props.infowindow.viewinfopanel) {
        return _react2.default.createElement(
          "span",
          null,
          this.renderPanelPropiertiesConfigEstil(),
          this.renderPanelPropertiesConfigFields()
        );
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        _semanticUiReact.Segment,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { className: _PanelMapInformation2.default.gridInformacio },
          this.renderToggleLlegenda(),
          _react2.default.createElement(_semanticUiReact.Divider, { className: _PanelMapInformation2.default.myDivider }),
          this.renderToggleFilter(),
          _react2.default.createElement(_semanticUiReact.Divider, { className: _PanelMapInformation2.default.myDivider }),
          this.renderToggleCercador(),
          _react2.default.createElement(_semanticUiReact.Divider, { className: _PanelMapInformation2.default.myDivider }),
          this.renderToggleTitol(),
          _react2.default.createElement(_semanticUiReact.Divider, { className: _PanelMapInformation2.default.myDivider }),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { className: _PanelMapInformation2.default.row2 },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16 },
              _react2.default.createElement(_semanticUiReact.Icon, { name: "edit" }),
              " Personalitzar panell info."
            )
          ),
          this.renderPanelConfig()
        )
      );
    }
  }]);

  return PanelMapInformation;
}(_react.Component);

exports.default = PanelMapInformation;

PanelMapInformation.propTypes = {
  thematics: _propTypes2.default.array,
  tooltipfields: _propTypes2.default.array,
  infowindow: _propTypes2.default.object,
  onChange: _propTypes2.default.func,
  removeViz: _propTypes2.default.func,
  updateInfowindowProps: _propTypes2.default.func,
  calcdatafields: _propTypes2.default.array,
  selectedfieldsLabels: _propTypes2.default.object,
  updateSelectedfieldsLabels: _propTypes2.default.func
};
